import SectionHeader from './SectionHeader'

export { SectionHeader }

export default SectionHeader
